import React from 'react'
import { tints } from '@manychat/manyui'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const CommonViewStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: sharedStyles.Colors.TRIGGER_BG,
  borderRadius: sharedStyles.BorderRadius.MEDIUM,
  marginTop: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
  marginBottom: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
  padding: toPx(sharedStyles.Spacings.NORMAL),
  border: `${toPx(sharedStyles.BorderWidth.NORMAL)} solid ${sharedStyles.Colors.TRIGGER_BG}`,
}

export const DisabledCommonViewStyle = {
  border: `${toPx(sharedStyles.BorderWidth.NORMAL)} solid ${
    sharedStyles.Colors.DISABLED_TRIGGER_BG
  }`,
  backgroundColor: sharedStyles.Colors.DISABLED_TRIGGER_BG,
}

export const SelectedCommonViewStyle = {
  border: `${toPx(sharedStyles.BorderWidth.NORMAL)} solid ${sharedStyles.Colors.GREEN}`,
}

export const ViewStyle = {
  display: 'flex',
}

export const ViewColumnStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
}

export const TextViewStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  marginLeft: toPx(sharedStyles.Spacings.NORMAL),
  paddingRight: toPx(sharedStyles.Spacings.EXTRA_EXTRA_SMALL),
}

export const IconStyle = {
  width: sharedStyles.IconSizes.MEDIUM,
  height: sharedStyles.IconSizes.MEDIUM,
  flexShrink: 0,
}

export const DisabledLabelStyle = {
  flexShrink: 0,
  padding: '0 6px',
  backgroundColor: '#CED1D8',
  borderRadius: toPx(sharedStyles.BorderRadius.EXTRA_SMALL),
  marginTop: '6px',
  display: 'flex',
  marginLeft: toPx(sharedStyles.Spacings.NORMAL),
}

export const DisabledLabelTextStyle = {
  ...sharedStyles.text,
  ...sharedStyles.textSecondary,
  fontSize: '18px',
}

export const TextStyle = {
  ...sharedStyles.subheading,
  lineHeight: '25px',
  marginBottom: toPx(sharedStyles.Spacings.SMALL),
}
export const SubTextStyle = {
  ...sharedStyles.preheader,
  marginTop: toPx(sharedStyles.Spacings.EXTRA_EXTRA_SMALL),
  color: tints.neutral[2],
}

export const TriggerTitleStyle = {
  ...sharedStyles.subheading,
  fontSize: 20,
  lineHeight: '32px',
  fontWeight: 900,
}

export const SubtitleWithIconStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
}

export const SubtitleIcon: React.CSSProperties = {
  flexShrink: 0,
  width: toPx(sharedStyles.IconSizes.SMALL_MEDIUM),
  height: toPx(sharedStyles.IconSizes.SMALL_MEDIUM),
  marginRight: toPx(sharedStyles.Spacings.EXTRA_SMALL),
  marginTop: toPx(sharedStyles.Spacings.EXTRA_SMALL),
}
